import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Apollo} from 'apollo-angular';
import {NotificationService} from 'src/app/services/notification.service';
import {ResponseCodeService} from 'src/app/services/response-code.service';
import * as fromActions from "./citizen-verify-opt-number.actions";
import * as fromGraphql from "./citizen-verify-opt-number.graphql";
import {map, switchMap} from 'rxjs';
import {Router} from "@angular/router";



@Injectable()
export class CitizenVerifyOptNumberEffects {

  citizenVerifyOtpNumber = createEffect(() => this.actions$.pipe(
    ofType(fromActions.citizenVerifyOtpNumber),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CITIZEN_VERIFY_OPT_NUMBER,
        variables: {
          otp: action?.otp,
          phoneNumber: action?.phoneNumber,
          userEmail: action?.userEmail
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.status) {
              if(action.navTo === 'login'){
                this.notificationService.successMessage('OTP Verified, Account Created Successfully');
                this.router.navigate([`/login`])
              }else{
                this.notificationService.successMessage('OTP Verified Successfully');
                this.router.navigate([`/set-new-password/${action.phoneNumber}`])
              }
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  resendOtpNumber$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.resendOtpNumber),
    switchMap((action) => {
      const variables: any = {};

      if (action.inputType === 'EMAIL') {
        variables.userEmail = action.newValue;
        variables.previousEmail = action.previousValue;
      } else {
        variables.phoneNumber = action.newValue;
        variables.previousPhoneNumber = action.previousValue;
      }

      return this.apollo.mutate({
        mutation: fromGraphql.RESEND_OTP_NUMBER,
        variables: variables
      }).pipe(
        this.notificationService.catchError('Problem occurred while sending OTP'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.status) {
              this.notificationService.successMessage('OTP Sent Successfully');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private router: Router,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
